import "./AiInfoCardBlock.scss";
import { AiInfoCardBlockProps } from "/Models/Generated/AiInfoCardBlockProps";
import cn from "classnames";

export enum BackgroundColor {
  light = "light",
  medium = "medium",
  pop = "pop",
}
interface Props extends AiInfoCardBlockProps {
  onClickHandler?: () => void;
  backgroundColor?: BackgroundColor;
}

const AiInfoCardBlock = ({
  description,
  onClickHandler,
  backgroundColor,
}: Props) => {
  return (
    <button
      onClick={onClickHandler}
      className={cn("ai-info-card-block-norad", backgroundColor ?? "")}
    >
      {description}
    </button>
  );
};

export default AiInfoCardBlock;
